import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import { fixTaxon, fixProductTaxons } from '@/service/upgradeService'

export default {
	namespaced: true,
	state: {
		channel: "",
		currentTaxon: "dumplings",
		categories: [],
		products: [],
		highlightProducts: [],
		filters: [],
		loading: false,
	},
	actions: {
		async loadProductList({ state, commit, rootState }, { taxon, accumulatorGroup = null } = { taxon: null }) {
			commit('setLoading', { item: true })
			if (rootState.cart.serverData) {
				//TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
			} else {
				state.channel = config.DEFAULT_CHANNEL
			}

			if (taxon) {
				commit('setActiveCategory', {item: taxon})
			}

			// don't load products, if there is no channel, to prevent wrong prices or products.
			// this mostly applies to calls before the cart has been retrieved
			if (!state.channel) {
				commit('setLoading', { item: false })
				return;
			}

			const products = await service.products({ channel: state.channel, slug: state.currentTaxon, token: rootState.cart.basketToken, accumulatorGroup })

			//map products
			let productList = products.items.reduce((p, c) => {
				fixProductTaxons(c)
				let item = {
					tags: c.attributes.reduce((p, c) => {
						if (c.code == "tags") {
							//TODO: we can remove this check in a future version
							if (!(c.value instanceof Array)) {
								throw new Error("productlist::readTags deprecated API")
							}
							p = p.concat(
								c.value.map(v => v["key"])
							)
						}
						return p
					}, []),
					// add default stock
					stock: -1,
					...c,

					variants: Object.entries(c.variants).reduce((p, [k, v]) => {
						//polyfill stock
						v.stock = v.stock == null ? -1 : v.stock
						p[k] = v
						return p
					}, {})
				}
				p.push(item)
				return p
			}, [])

			commit('setProducts', {item: productList})
			commit('setLoading', { item: false })
		},




		async loadHighlightProducts({ state, commit, rootState }, { accumulatorGroup = null } = { }) {
			commit('setLoading', { item: true })

			const products = await service.highlightProducts({ channel: state.channel || config.DEFAULT_CHANNEL, token: rootState.cart.basketToken, accumulatorGroup })

			//map products
			let productList = products.items.reduce((p, c) => {
				fixProductTaxons(c)
				let item = {
					tags: c.attributes.reduce((p, c) => {
						if (c.code == "tags") {
							//TODO: we can remove this check in a future version
							if (!(c.value instanceof Array)) {
								throw new Error("productlist::readTags deprecated API")
							}
							p = p.concat(
								c.value.map(v => v["key"])
							)
						}
						return p
					}, []),
					// add default stock
					stock: -1,
					...c,

					variants: Object.entries(c.variants).reduce((p, [k, v]) => {
						//polyfill stock
						v.stock = v.stock == null ? -1 : v.stock
						p[k] = v
						return p
					}, {})
				}
				p.push(item)
				return p
			}, [])

			commit('setHighlightProducts', {item: productList})
			commit('setLoading', { item: false })
		},




		async loadCategories({ state, commit, rootState }, { entrypoint, accumulatorGroup = null } = { entrypoint: "madamesum" }) {
			if (rootState.cart.serverData) {
				//TODO: this access should be less based on serverdata
				state.channel = rootState.cart.serverData.channel.code
			} else {
				state.channel = config.DEFAULT_CHANNEL
			}

			const result = await service.taxons({ entrypoint, channel: state.channel, accumulatorGroup, token: rootState.cart.basketToken })

			let categoryList = fixTaxon(result.self).children
			let firstTaxon = categoryList[0]
			while (firstTaxon && firstTaxon.children.length > 0) {
				// search for the first cat
				firstTaxon = firstTaxon.children[0]
			}
			let firstCat = firstTaxon != null
				? firstTaxon.code
				: ''

			commit('setCategories', {item: categoryList})
			commit('setActiveCategory', {item: firstCat})
		},

		async readFilters({state, commit, dispatch}) {
			let data = []
			//TODO: htmlinput should maybe be outsourced here
			//read form html
			const el = document.querySelector(config.SHOPLIST_TAGS_SELECTOR)
			if (el && el.getAttribute("type") == "application/json") {
				let htmlData = JSON.parse(el.innerHTML.replace(/^\s+/, ""))
				if (htmlData.choices) {
					data = Object.entries(htmlData.choices)
						.map(([k, v]) => ({
							id: k,
							label: v[config.LOCALE],
							active: false,
							group: "", //HACK: we do not have date to describe group
						}))
				}

			}
			if (!data || data.length < 0) {

				//DEBUG: this data is no longer used
				// console.warn("productlist: no filter data found, use default")
				data = [
					{ id: "vegi", label: "Vegi", active: false, group: "Deine Lieblings" },
					{ id: "Superfood", label: "Superfood", active: false, group: "Deine Lieblings" },
					{ id: "glutenfree", label: "glutenfree", active: false, group: "Deine Lieblings" },
					{ id: "Beliebteste", label: "Beliebteste", active: false, group: "Allgemein" },
					{ id: "Laktosefrei", label: "Laktosefrei", active: false, group: "Allgemein" },
					{ id: "Nüsse", label: "Nüsse", active: false, group: "Allergien" },
				]
			}

			commit('setFilters', {
				item: data
			})

		},

		async setFilter({state, commit}, {filterId, active}) {
			let filter = state.filters.find(f => f.id == filterId)
			if (filter) {
				filter.active = active
				commit('setFilterState', { item: filter})
			}
		}
	},
	getters: {
		productsLoading(state) {
			return state.loading;
		},
		products(state) {
			return state.products ? state.products : []
		},
		highlightProducts(state) {
			return state.highlightProducts ? state.highlightProducts : []
		},
		categories(state) {
			return state.categories ? state.categories : []
		},
		filters(state) {
			return state.filters
		},
		filtersActive(state) {
			return state.filters
				.filter(f => f.active)
				.map(f => f.id)
		},
		favoriteCode(state) {
			return 'favorite'
		},
		currentTaxon(state) {
			return state.currentTaxon
		},
		currentTaxonPath(state, getters) {
			let path = []
			const buildRecur = (categories, taxon, path) => {
				const res = categories.some(cat => {
					if (cat.code == taxon) {
						path.push(cat)
						return true
					} else if (cat.children) {
						let childRes = buildRecur(cat.children, taxon, path)
						if (childRes) {
							path.push(cat)
						}
					} else {
						return false
					}
				})
				return res
			}

			// build path deep first
			buildRecur(getters.categories, state.currentTaxon, path)

			// we have to revers the path because searchin
			path = path.reverse()

			return path
		},
		currentSubCategories(state, getters) {
			let path = getters.currentTaxonPath
			if (path.length > 0) {
				return path[0].children
			}
			return []
		}
	},
	mutations: {
		setActiveCategory: generateSetChild('currentTaxon'),
		setProducts: generateSetChild('products'),
		setHighlightProducts: generateSetChild('highlightProducts'),
		setCategories: generateSetChild('categories'),
		setFilters: generateSetChild('filters'),
		setFilterState: generateUpdateArrayChild('filters'),
		setLoading: generateSetChild('loading'),
	}
}
